<template>
  <v-dialog
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        Pick Up by Tension Beats
      </v-card-title>
      <v-card-text v-if="loading" class="text-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </v-card-text>
      <v-card-text v-else>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th rowspan="2" class="text-left"></th>
                <th
                  v-for="value in tensionBeats"
                  :key="value"
                  class="text-center"
                  colspan="2"
                >
                  {{ value }}
                </th>
              </tr>
              <tr>
                <template v-for="value in tensionBeats">
                  <th :key="`${value}-per-session`" class="text-center">
                    per Session
                  </th>
                  <th :key="`${value}-total`" class="text-center">
                    Total
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-if="items.length === 0">
                <td class="text-center caption" colspan="3">No data</td>
              </tr>
              <template v-else>
                <tr
                  v-for="item in items"
                  :key="item.name"
                >
                  <td class="caption">{{ item.name }}</td>
                  <template v-for="value in tensionBeats">
                    <th :key="`${value}-per-session-body`" class="caption text-center">
                      {{ item[value] ? (item[value].val / (item[value].players || 1)).toFixed(2) : 0 }}
                    </th>
                    <th :key="`${value}-total-body`" class="caption text-center">
                      {{ item[value] ? item[value].val : 0 }}
                    </th>
                  </template>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      tensionBeats: [],
      dialog: true,
      loading: true,
      items: []
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        setTimeout(() => {
          this.$emit('close')
        }, 500)
      }
    },
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-pick-up/tension-beats`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.items = data.data
        this.tensionBeats = data.tensionBeats
      }
      this.loading = false
    }
  }
}
</script>